import "core-js/modules/es.array.push.js";
import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "list-page-table-panel p-5"
};
const _hoisted_2 = {
  class: "flex flex-wrap items-center gap-2"
};
const _hoisted_3 = {
  class: "relative min-w-[240px] flex-1"
};
const _hoisted_4 = {
  class: "list-page-segmented"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "flex items-center gap-1 text-xs text-slate-500"
};
const _hoisted_7 = ["disabled"];
const _hoisted_8 = {
  class: "mt-3 flex flex-wrap items-center gap-1.5"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "ml-auto flex items-center gap-1.5"
};
const _hoisted_11 = {
  class: "mb-2 flex flex-wrap items-center gap-2"
};
const _hoisted_12 = {
  class: "text-sm font-semibold text-slate-900"
};
const _hoisted_13 = {
  class: "status-badge is-neutral"
};
const _hoisted_14 = {
  key: 0,
  class: "text-[11px] text-slate-400"
};
const _hoisted_15 = {
  key: 1,
  class: "status-badge is-danger"
};
const _hoisted_16 = {
  key: 0,
  class: "flex items-center gap-2 py-6 text-xs text-slate-400"
};
const _hoisted_17 = {
  key: 1,
  class: "empty-state is-compact"
};
const _hoisted_18 = {
  class: "empty-state-desc"
};
const _hoisted_19 = {
  key: 2,
  class: "empty-state is-compact"
};
const _hoisted_20 = {
  key: 3,
  class: "space-y-2"
};
const _hoisted_21 = {
  key: 1,
  class: "empty-state"
};
import { computed, reactive, ref } from 'vue';
import SpaceHitCard from './SpaceHitCard.vue';
import { searchSpaces } from '@/api/aiSpace';
export default {
  __name: 'SpaceRecallPanel',
  props: {
    /** 可选空间范围（我的空间列表） */
    spaces: {
      type: Array,
      default: () => []
    }
  },
  emits: ['preview'],
  setup(__props) {
    const MODE_OPTIONS = [{
      value: 'vector',
      label: '向量'
    }, {
      value: 'hybrid',
      label: '混合'
    }, {
      value: 'compare',
      label: '并排对比'
    }];
    const query = ref('');
    const mode = ref('vector');
    const topK = ref(8);
    const selectedIds = ref([]);
    const filterUploader = ref(''); // filters.uploader（等值，可空）
    const filterFilename = ref(''); // filters.filename_like（子串，可空）
    const filterAfter = ref(''); // filters.uploaded_after（yyyy-MM-dd，可空）
    const filterBefore = ref(''); // filters.uploaded_before（闭区间含当天）
    const loading = ref(false);
    const hasRun = ref(false);
    const lastQuery = ref('');

    /** 组装 §9 filters：空值不传；全空返回 null（payload 不带 filters 字段） */
    function buildFilters() {
      const filters = {};
      const u = filterUploader.value.trim();
      const fl = filterFilename.value.trim();
      if (u) filters.uploader = u;
      if (fl) filters.filename_like = fl;
      const af = filterAfter.value.trim();
      const bf = filterBefore.value.trim();
      if (af) filters.uploaded_after = af;
      if (bf) filters.uploaded_before = bf;
      return Object.keys(filters).length ? filters : null;
    }

    /** 两模式各自结果（并排对比时同时填充） */
    const results = reactive({
      vector: {
        hits: [],
        queryCost: null,
        error: '',
        loading: false
      },
      hybrid: {
        hits: [],
        queryCost: null,
        error: '',
        loading: false
      }
    });
    const isCompare = computed(() => mode.value === 'compare');
    const resultColumns = computed(() => {
      const cols = [];
      if (mode.value === 'vector' || mode.value === 'compare') {
        cols.push({
          mode: 'vector',
          ...results.vector
        });
      }
      if (mode.value === 'hybrid' || mode.value === 'compare') {
        cols.push({
          mode: 'hybrid',
          ...results.hybrid
        });
      }
      return cols;
    });
    function toggleSpace(id) {
      const idx = selectedIds.value.indexOf(id);
      if (idx === -1) selectedIds.value.push(id);else selectedIds.value.splice(idx, 1);
    }
    function formatCost(cost) {
      if (!cost) return '';
      const parts = [];
      if (cost.embed != null) parts.push(`embed ×${cost.embed}`);
      if (cost.rerank != null) parts.push(`rerank ×${cost.rerank}`);
      return parts.length ? `query_cost: ${parts.join(' / ')}` : '';
    }
    async function searchOne(targetMode) {
      const slot = results[targetMode];
      slot.loading = true;
      slot.error = '';
      try {
        const payload = {
          spaceIds: selectedIds.value.slice(),
          query: lastQuery.value,
          topK: topK.value,
          mode: targetMode
        };
        const filters = buildFilters();
        if (filters) payload.filters = filters;
        const data = await searchSpaces(payload);
        slot.hits = data && data.hits || [];
        slot.queryCost = data && data.query_cost || null;
      } catch (error) {
        slot.hits = [];
        slot.queryCost = null;
        slot.error = error && error.message || '检索失败';
      } finally {
        slot.loading = false;
      }
    }
    async function runSearch() {
      const q = query.value.trim();
      if (!q) return;
      lastQuery.value = q;
      hasRun.value = true;
      loading.value = true;
      try {
        if (isCompare.value) {
          // 两模式各调一次，并排展示
          await Promise.all([searchOne('vector'), searchOne('hybrid')]);
        } else {
          await searchOne(mode.value);
        }
      } finally {
        loading.value = false;
      }
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => query.value = $event),
        type: "text",
        class: "form-search-input form-control-sm w-full",
        placeholder: "输入测试问题（如：研发费用占比要求）",
        onKeyup: _withKeys(runSearch, ["enter"])
      }, null, 544), [[_vModelText, query.value]]), _cache[8] || (_cache[8] = _createElementVNode("svg", {
        class: "absolute left-3 top-2.5 h-4 w-4 text-slate-400",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
      })], -1))]), _createElementVNode("div", _hoisted_4, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(MODE_OPTIONS, opt => {
        return _createElementVNode("button", {
          key: opt.value,
          class: _normalizeClass(["list-page-segmented-item", {
            'is-active': mode.value === opt.value
          }]),
          onClick: $event => mode.value = opt.value
        }, _toDisplayString(opt.label), 11, _hoisted_5);
      }), 64))]), _createElementVNode("label", _hoisted_6, [_cache[10] || (_cache[10] = _createTextVNode(" topK ", -1)), _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => topK.value = $event),
        class: "form-select-native form-control-sm"
      }, [...(_cache[9] || (_cache[9] = [_createElementVNode("option", {
        value: 5
      }, "5", -1), _createElementVNode("option", {
        value: 8
      }, "8", -1), _createElementVNode("option", {
        value: 10
      }, "10", -1), _createElementVNode("option", {
        value: 20
      }, "20", -1)]))], 512), [[_vModelSelect, topK.value, void 0, {
        number: true
      }]])]), _createElementVNode("button", {
        class: "btn-primary form-control-sm",
        disabled: loading.value,
        onClick: runSearch
      }, _toDisplayString(loading.value ? '检索中…' : '执行检索'), 9, _hoisted_7)]), _createElementVNode("div", _hoisted_8, [_cache[11] || (_cache[11] = _createElementVNode("span", {
        class: "text-xs text-slate-400"
      }, "空间范围：", -1)), _createElementVNode("button", {
        class: _normalizeClass(["inline-flex items-center gap-1 rounded-md px-2 py-0.5 text-xs transition-colors", selectedIds.value.length === 0 ? 'bg-blue-50 text-blue-700 ring-1 ring-blue-200' : 'bg-slate-100 text-slate-500 hover:bg-slate-200']),
        onClick: _cache[2] || (_cache[2] = $event => selectedIds.value = [])
      }, "全部可见", 2), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.spaces, s => {
        return _openBlock(), _createElementBlock("button", {
          key: s.id,
          class: _normalizeClass(["inline-flex items-center gap-1 rounded-md px-2 py-0.5 text-xs transition-colors", selectedIds.value.includes(s.id) ? 'bg-blue-50 text-blue-700 ring-1 ring-blue-200' : 'bg-slate-100 text-slate-500 hover:bg-slate-200']),
          onClick: $event => toggleSpace(s.id)
        }, "📚 " + _toDisplayString(s.name), 11, _hoisted_9);
      }), 128)), _createElementVNode("span", _hoisted_10, [_withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => filterUploader.value = $event),
        class: "form-input form-control-sm w-24",
        placeholder: "上传者",
        title: "过滤：上传者（metadata 等值）"
      }, null, 512), [[_vModelText, filterUploader.value]]), _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => filterFilename.value = $event),
        class: "form-input form-control-sm w-28",
        placeholder: "文件名包含",
        title: "过滤：文件名子串（大小写不敏感）"
      }, null, 512), [[_vModelText, filterFilename.value]]), _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => filterAfter.value = $event),
        type: "date",
        class: "form-input form-control-sm w-36",
        title: "过滤：上传时间 ≥（契约 v1.4，仅对新入库文件生效）"
      }, null, 512), [[_vModelText, filterAfter.value]]), _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => filterBefore.value = $event),
        type: "date",
        class: "form-input form-control-sm w-36",
        title: "过滤：上传时间 ≤（契约 v1.4，仅对新入库文件生效）"
      }, null, 512), [[_vModelText, filterBefore.value]])])]), hasRun.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["mt-4", isCompare.value ? 'grid grid-cols-1 gap-4 xl:grid-cols-2' : ''])
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resultColumns.value, col => {
        return _openBlock(), _createElementBlock("div", {
          key: col.mode,
          class: "min-w-0"
        }, [_createElementVNode("div", _hoisted_11, [_createElementVNode("h3", _hoisted_12, _toDisplayString(col.mode === 'hybrid' ? '混合检索 + Rerank' : '向量检索'), 1), _createElementVNode("span", _hoisted_13, _toDisplayString(col.hits.length) + " 命中", 1), col.queryCost ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(formatCost(col.queryCost)), 1)) : _createCommentVNode("", true), col.error ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(col.error), 1)) : _createCommentVNode("", true)]), col.loading ? (_openBlock(), _createElementBlock("div", _hoisted_16, [...(_cache[12] || (_cache[12] = [_createElementVNode("span", {
          class: "app-spinner is-sm"
        }, null, -1), _createTextVNode(" 检索中… ", -1)]))])) : col.error ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_cache[13] || (_cache[13] = _createElementVNode("div", {
          class: "empty-state-icon"
        }, "⚠️", -1)), _cache[14] || (_cache[14] = _createElementVNode("p", {
          class: "empty-state-title"
        }, "检索失败", -1)), _createElementVNode("p", _hoisted_18, _toDisplayString(col.error), 1)])) : !col.hits.length ? (_openBlock(), _createElementBlock("div", _hoisted_19, [...(_cache[15] || (_cache[15] = [_createElementVNode("div", {
          class: "empty-state-icon"
        }, "🔍", -1), _createElementVNode("p", {
          class: "empty-state-title"
        }, "无命中分段", -1), _createElementVNode("p", {
          class: "empty-state-desc"
        }, "换个问法或扩大空间范围试试", -1)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(col.hits, (h, i) => {
          return _openBlock(), _createBlock(SpaceHitCard, {
            key: h.doc_id || i,
            hit: h,
            query: lastQuery.value,
            index: i,
            onPreview: _cache[7] || (_cache[7] = hit => _ctx.$emit('preview', hit))
          }, null, 8, ["hit", "query", "index"]);
        }), 128))]))]);
      }), 128))], 2)) : (_openBlock(), _createElementBlock("div", _hoisted_21, [...(_cache[16] || (_cache[16] = [_createElementVNode("div", {
        class: "empty-state-icon"
      }, "🎯", -1), _createElementVNode("p", {
        class: "empty-state-title"
      }, "召回测试", -1), _createElementVNode("p", {
        class: "empty-state-desc"
      }, "输入问题执行检索，查看命中分段、得分与来源定位；支持向量/混合两模式并排对比", -1)]))]))]);
    };
  }
};